export function browserType(): 'mob' | 'pc' {
  const sUserAgent = navigator.userAgent.toLowerCase(); //浏览器的用户代理设置为小写，再进行匹配
  const isIpad = sUserAgent.match(/ipad/i)?.[0] == 'ipad'; //或者利用indexOf方法来匹配
  const isIphoneOs = sUserAgent.match(/iphone os/i)?.[0] == 'iphone os';
  const isMidp = sUserAgent.match(/midp/i)?.[0] == 'midp'; //移动信息设备描述MIDP是一套Java应用编程接口，多适用于塞班系统
  const isUc7 = sUserAgent.match(/rv:1.2.3.4/i)?.[0] == 'rv:1.2.3.4'; //CVS标签
  const isUc = sUserAgent.match(/ucweb/i)?.[0] == 'ucweb';
  const isAndroid = sUserAgent.match(/android/i)?.[0] == 'android';
  const isCe = sUserAgent.match(/windows ce/i)?.[0] == 'windows ce';
  const isWM = sUserAgent.match(/windows mobil/i)?.[0] == 'windows mobil';

  if (isIpad || isIphoneOs || isMidp || isUc7 || isUc || isAndroid || isCe || isWM) {
    return 'mob';
  }

  return 'pc';
}

export function isImageUrl(url: string): boolean {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.tiff'];

  try {
    const urlExtension = new URL(url).pathname.split('.').pop()?.toLowerCase();

    return urlExtension ? imageExtensions.includes(`.${urlExtension}`) : false;
  } catch (err) {
    return false;
  }
}

export function showToast(content: string, _container?: HTMLElement): void {
  const ANIM_TIME = 200;
  const TOAST_TIME = 2000;
  const container = _container || document.getElementById('mvMindContainer');
  const toastContainer = document.createElement('div');

  if (container && toastContainer) {
    toastContainer.style.boxSizing = 'border-box';
    toastContainer.style.fontSize = '14px';
    toastContainer.style.color = '#FFFFFF';
    toastContainer.style.display = 'inherit';
    toastContainer.style.lineHeight = '20px';
    toastContainer.style.borderRadius = '10px';
    toastContainer.style.background = 'rgba(52, 52, 52, 0.8)';
    toastContainer.style.paddingLeft = '22px';
    toastContainer.style.paddingRight = '22px';
    toastContainer.style.paddingTop = '10px';
    toastContainer.style.paddingBottom = '10px';
    toastContainer.style.position = 'absolute';
    toastContainer.style.top = '50%';
    toastContainer.style.left = '50%';
    toastContainer.style.transform = `translate(-50%, -50%)`;
    toastContainer.style.maxWidth = '80%';
    toastContainer.style.textOverflow = 'ellipsis';
    toastContainer.style.overflow = 'hidden';
    toastContainer.style.zIndex = '100000';
    toastContainer.style.opacity = '0';
    toastContainer.style.fontFamily = "'Helvetica Neue', Helvetica, sans-serif";

    toastContainer.innerText = content;
    container.appendChild(toastContainer);

    toastContainer.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: ANIM_TIME,
      fill: 'forwards'
    });
    setTimeout(() => {
      toastContainer.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: ANIM_TIME,
        fill: 'forwards'
      });
      setTimeout(() => {
        container.removeChild(toastContainer);
      }, ANIM_TIME);
    }, TOAST_TIME);
  }
}

export const CONTAINER_EVENT = {
  MIND_UPDATE: 'mv_container_MIND_UPDATE',
  NEED_LOGIN: 'mv_container_NEED_LOGIN', // 用户未登录，触发登录弹窗
  TRIAL_OVER: 'mv_container_TRIAL_OVER', // 免费试用次数完毕，弹窗提醒
  UPDATE_SUBSCRIPTION: 'mv_mindcommerse_UPDATE_SUBSCRIPTION', // same to EVENT.UPDATE_SUBSCRIPTION
  EVENT_SHORTCUT_UPDATE: 'MV_CONTAINER_EVENT_SHORTCUT_UPDATE', // mindos更新shortcut 内部实时更新
  SHORTCUT_LOADING: 'SHORTCUT_LOADING', // 触发shortcut的时候改变listLoading状态
  SEND_MESSAGE: 'SEND_MESSAGE', // 触发发送信息
  ANSWERED: 'GREETING_READIED', // 回答完毕(index === -1)
  STOP_ANSWER: 'STOP_ANSWER', // 停止回答
  SCRAWL_CARD_READIED: 'SCRAWL_CARD_READIED', // 汇总卡片已展示，目前用于通知 mindos 引导
  CANVAS_GUIDE_READIED: 'CANVAS_GUIDE_READIED', // canvas 引导已展示，为了解决发的消息先收到 -1，然后才做渲染的问题。
  SHOW_POPOVER: 'SHOW_POPOVER', // 展示 popover，通知 用户引导
  CANVAS_MARKDOWN_LOAD: 'CANVAS_MARKDOWN_LOAD', // canvas markdown 加载完成
  CANVAS_SHOW_QUOTE: 'CANVAS_SHOW_QUOTE', // 显示 quote
  SET_INPUT_VALUE: 'SET_INPUT_VALUE', // 外部更改输入框的值
  CHAT_INPUT_FOCUS: 'CHAT_INPUT_FOCUS', // 聚焦输入框
  CHAT_INPUT_BLUR: 'CHAT_INPUT_BLUR', // 失焦输入框
  OPEN_SESSION_WITH_SOURCE: 'OPEN_SESSION_WITH_SOURCE', // 从站内信通知重开 session 并自带上下文
  RESTART_SESSION: 'RESTART_SESSION', // 重开 session
  CLOSE_SESSION_FINISHED: 'CLOSE_SESSION_FINISHED', // 关闭 session 完成
  CLOSE_SESSION: 'CLOSE_SESSION', // 关闭session
  ONBOARD: 'ONBOARD', // 进入启动页
  CLOSE_ONBOARD: 'CLOSE_ONBOARD', // 关闭启动页
  CREATE_SESSION: 'CREATE_SESSION', // 创建session
  SEND_NOTE_SUGGESTION_MESSAGE: 'SEND_NOTE_SUGGESTION_MESSAGE', // 发送note suggestion(需要在开场白发完且进入canvas模式才发送消息)
  RESTORE_INPUT_VALUE: 'RESTORE_INPUT_VALUE' // 发送失败时恢复输入框内容
};

export interface SessionSourceInterface {
  sessionId?: string;
}

export interface EventCreateSessionInterface {
  params: {
    newSession?: boolean;
    originSessionId?: string;
    extParams?: Record<string, any>;
  };
  callback?: (sessionId: string) => void;
  friendInfo?: {
    isFriend: boolean;
    friendUserId: string;
    friendUserName: string;
    friendUserLabel: string;
  };
}

export const INNER_EVENT = {
  RESEND_MSG: 'RESEND_MSG',
  HISTORY_MSG: 'HISTORY_MSG', // 历史消息
  SCROLL_TO_BOTTOM: 'SCROLL_TO_BOTTOM', // 滚动到最底部
  LOAD_: '已加载到历史记录', // 滚动到最底部
  HIDE_PORTFOLIO: 'HIDE_PORTFOLIO' // 触发隐藏作品集
};

export interface Tag {
  tagName: string;
  tagValue: string;
}

export function convertTagsToObject(tags: Tag[]): { [key: string]: string } {
  const result: { [key: string]: string } = {};

  tags.forEach((tag) => {
    result[tag.tagName] = tag.tagValue;
  });

  return result;
}

export function convertObjectToTags(obj: { [key: string]: string }): Tag[] {
  const tags: Tag[] = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      tags.push({
        tagName: key,
        tagValue: obj[key]
      });
    }
  }

  return tags;
}

export function isObjectEmpty(obj: unknown): boolean {
  // Check if the input is an object
  if (typeof obj !== 'object' || obj === null) {
    return true;
  }

  // Get the keys of the object
  const keys = Object.keys(obj);

  // Check if the object has no keys
  if (keys.length === 0) {
    return true;
  }

  return false;
}

export const copyToClipboard = (textToCopy: string) => {
  return new Promise<void>((resolve, reject) => {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement('textarea');

      textArea.value = textToCopy;

      // Move textarea out of the viewport so it's not visible
      textArea.style.position = 'absolute';
      textArea.style.left = '-999999px';

      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        textArea.remove();
        resolve();
      } catch (error) {
        textArea.remove();
        reject(error);
      } finally {
        textArea.remove();
      }
    }
  });
};

export function canOpenInCanvas(url: string): boolean {
  return (
    url.startsWith('https://cdn.mindverse.ai/mindos-resource') ||
    url.startsWith('https://frontdoorcdn.mindverse.ai/mindos-resource') ||
    url.endsWith('.pdf')
  );
}

export function getGMTNumber(): string {
  const d = new Date();
  const offset = d.getTimezoneOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const sign = offset > 0 ? '-' : '+';

  return `GMT${sign}${hours}`;
}
export function getShowFileType(link: string): string {
  if (!link) {
    return '';
  }

  let path = link;

  try {
    const urlInstance = new URL(link);

    path = urlInstance.pathname;
  } catch (e) {
    console.error(e);

    return '';
  }

  const index = path.lastIndexOf('.');

  if (index == -1) return '';

  const mart = path.slice(index + 1).toUpperCase();

  return mart;
}
export function getFileType(link: string): string {
  const mart = getShowFileType(link).toLowerCase();

  return (
    {
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      txt: 'text/plain',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      pdf: 'application/pdf',
      csv: 'text/csv',
      xls: 'application/vnd.ms-excel',
      xlt: 'application/vnd.ms-excel',
      xla: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
      xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
      xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
      xlam: 'application/vnd.ms-excel.addin.macroEnabled.12',
      xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    }[mart] || ''
  );
}
